import { shuffleArray } from '@/utils'

export default {
    namespaced: true,
    state: {
        NumberOfPlayersPerTeam: 0,
        Rounds: [],
        RoundNumber: 1,
        ScoresHistory: [],
        GameStarted: false
    },
    mutations: {
        UPDATE_NUMBEROFPLAYERSPERTEAM: (state, value) => state.NumberOfPlayersPerTeam = value,
        AppendRounds: (state, rounds) => state.Rounds = state.Rounds.concat(rounds),
        NextRound: (state) => state.RoundNumber++,
        PreviousRound: (state) => state.RoundNumber--,
        PopScoresHistory: (state) => state.ScoresHistory.pop(),
        PushScoresHistory: (state, history) => state.ScoresHistory.push(history),
        StartGame: (state) => state.GameStarted = true,
        ResetGame: (state) => {
            state.ScoresHistory = []
            state.Rounds = []
            state.RoundNumber = 1,
            state.GameStarted = false
        }
    },
    actions: {
        StartGame: ({ commit, dispatch }) => {
            commit('ResetGame')
            dispatch('GenerateRounds')
            commit('StartGame')
        },
        GenerateRounds: ({ commit, state, getters }) => {
            const SpecialRounds = ['Pairs', 'Impairs']
            const fillArrayWithNumbers = function(n) {
                var arr = Array.apply(null, Array(n));
                return arr.map(function (x, i) { return i + 1 });
            }
            let startSequence = fillArrayWithNumbers(state.NumberOfPlayersPerTeam)
            shuffleArray(startSequence)
            let result = []
            while (startSequence.length > 0) {
                let round = []
                let length = Math.ceil(Math.random() * 4)
                for (var i = 0; i < length; i++) {
                    if (startSequence.length == 0)
                        break;
                    round.push(startSequence.pop())
                }
                result.push({ id: getters.UniqueId(), round: round.sort((a, b) => a-b).join(', ') })
            }
            const addSpecialRounds = Math.random() > 0.5
            if (addSpecialRounds) {
                SpecialRounds.forEach((specialRound) => result.splice(Math.random() * result.length, 0, { id: getters.UniqueId(), round: specialRound }))
            }
            commit('AppendRounds', result)
        },
        Salade: ({ state, getters }) => {
            state.Rounds.splice(state.RoundNumber - 1, 0, { id: getters.UniqueId(), round: 'Salade' })
        },
        GivePoint:({ commit, state, dispatch }, team) => {
            commit('PushScoresHistory', team)
            commit('NextRound')
            if (state.RoundNumber == state.Rounds.length)
                dispatch('GenerateRounds')
        },
        Undo: ({ commit, state }, team) => {
            if (state.ScoresHistory.length == 0) return;
            commit('PopScoresHistory')
            commit('PreviousRound')
        }
    },
    getters: {
        CurrentRound: (state) => state.Rounds[state.RoundNumber - 1],
        PreviousRound: (state, getters) => state.Rounds[state.RoundNumber - 2] || { id: getters.UniqueId(), round: '' },
        NextRound: (state, getters) => state.Rounds[state.RoundNumber] || { id: getters.UniqueId(), round: '' },
        Scores: (state) => {
            return {
                Red: state.ScoresHistory.filter((h) => h == 'Red').length,
                Blue: state.ScoresHistory.filter((h) => h == 'Blue').length
            }
        },
        UniqueId: () => () => Math.random().toString(36).substr(2, 9)
    }
}